const METRICS = [
  { num: "<60 days", cap: "Idea to production for your first agentic application" },
  { num: "70%", pre: "up to", cap: "Routine business execution shifted to AI agents" },
  { num: ">95%", cap: "Assured agentic workflow precision" },
  { num: "30%", pre: "up to", cap: "Operating costs slashed with an agentic workforce" },
  { num: "3\u20135\u00D7", cap: "Faster rollout of subsequent agentic AI use cases" },
];

const PILLARS = [
  { k: "Speed", v: "AI value in days, not years" },
  { k: "Scale", v: "Agentic workflows across functions, not silos" },
  { k: "Sustenance", v: "Self-healing operations with predictable AI economics" },
];

const Label = ({ children }) => (
  <div className="bg-[#211307] text-[#EDA13A] font-mono2 text-xs uppercase tracking-[0.28em] px-6 py-3">{children}</div>
);

// ---------- OPTION D: Dark, centered, bordered metric cards ----------
export const CommitmentsD = () => (
  <section className="bg-[#211307] text-[#F7F5F0] py-16 lg:py-20" data-testid="commit-d">
    <div className="max-w-6xl mx-auto px-6 sm:px-8 text-center">
      <h2 className="font-display font-medium tracking-tight text-2xl sm:text-3xl lg:text-[2.5rem] leading-[1.12] max-w-3xl mx-auto">
        <span className="text-white/45">STOP</span> spending on AI experiments.<br />
        <span className="text-[#EDA13A]">START</span> achieving AI outcomes.
      </h2>
      <div className="mt-12 grid grid-cols-2 md:grid-cols-5 gap-3">
        {METRICS.map((m) => (
          <div key={m.cap} className="rounded-xl ring-1 ring-white/[0.12] bg-white/[0.03] px-4 py-6 hover:ring-[#EDA13A]/50 transition-colors duration-300">
            <div className="font-display font-medium text-3xl lg:text-[2.4rem] leading-none text-[#EDA13A]">{m.num}</div>
            <p className="mt-3 text-[11px] text-white/60 leading-snug">{m.cap}</p>
          </div>
        ))}
      </div>
      <div className="mt-9 flex flex-wrap justify-center gap-x-10 gap-y-2 text-xs">
        {PILLARS.map((p) => (
          <span key={p.k} className="text-white/70">
            <span className="font-mono2 uppercase tracking-[0.2em] text-[#E8AA68] mr-2">{p.k}</span>{p.v}
          </span>
        ))}
      </div>
    </div>
  </section>
);

// ---------- OPTION E: Warm gradient band, split ----------
export const CommitmentsE = () => (
  <section className="py-16 lg:py-20 bg-gradient-to-br from-[#2E1B0C] to-[#5A3418] text-[#F7F5F0]" data-testid="commit-e">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 grid lg:grid-cols-[1fr_1.25fr] gap-12 lg:gap-16 items-center">
      <div>
        <h2 className="font-display font-medium tracking-tight text-2xl sm:text-3xl lg:text-[2.5rem] leading-[1.12]">
          <span className="text-white/45">STOP</span> spending on AI experiments. <span className="text-[#F2C078]">START</span> achieving AI outcomes.
        </h2>
        <div className="mt-8 space-y-3">
          {PILLARS.map((p) => (
            <div key={p.k} className="flex gap-4">
              <div className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#F2C078] w-28 shrink-0 pt-0.5">{p.k}</div>
              <p className="text-sm text-white/75 leading-snug">{p.v}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-3 gap-x-6 gap-y-9 lg:border-l lg:border-white/15 lg:pl-12">
        {METRICS.map((m) => (
          <div key={m.cap}>
            {m.pre && <span className="block text-[10px] uppercase tracking-widest text-white/45 mb-1">{m.pre}</span>}
            <div className="font-display font-medium text-3xl lg:text-[2.5rem] leading-none text-[#FFCE85]">{m.num}</div>
            <p className="mt-3 text-[11px] text-white/65 leading-snug">{m.cap}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// ---------- OPTION F: Light "spec sheet" divided grid ----------
export const CommitmentsF = () => (
  <section className="bg-[#F7F5F0] text-[#3E2818] py-16 lg:py-20" data-testid="commit-f">
    <div className="max-w-7xl mx-auto px-6 sm:px-8">
      <h2 className="font-display font-medium tracking-tight text-2xl sm:text-3xl lg:text-[2.5rem] leading-[1.12] max-w-3xl">
        <span className="text-[#3E2818]/40">STOP</span> spending on AI experiments. <span className="text-[#8A5730]">START</span> achieving AI outcomes.
      </h2>
      <div className="mt-11 grid grid-cols-2 md:grid-cols-5 border-y border-[#3E2818]/12 md:divide-x divide-[#3E2818]/12">
        {METRICS.map((m) => (
          <div key={m.cap} className="px-5 py-7">
            {m.pre && <span className="block text-[10px] uppercase tracking-widest text-[#8A5730]/70 mb-1">{m.pre}</span>}
            <div className="font-display font-medium text-3xl lg:text-[2.5rem] leading-none text-[#8A5730]">{m.num}</div>
            <p className="mt-3 text-[11px] text-[#3E2818]/60 leading-snug">{m.cap}</p>
          </div>
        ))}
      </div>
      <div className="mt-8 grid md:grid-cols-3 gap-x-10 gap-y-3">
        {PILLARS.map((p) => (
          <div key={p.k} className="flex gap-3">
            <span className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#8A5730] pt-0.5">{p.k}</span>
            <span className="text-sm text-[#3E2818]/65 leading-snug">{p.v}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default function CommitmentsPreview2() {
  return (
    <div>
      <Label>Option D — Dark Metric Cards (centered)</Label>
      <CommitmentsD />
      <Label>Option E — Warm Gradient Split</Label>
      <CommitmentsE />
      <Label>Option F — Light Spec-Sheet Grid</Label>
      <CommitmentsF />
    </div>
  );
}
